/**
 * Asserts if the function is currently invoked in jest or cypress tests
 *
 * @returns boolean
 * @see https://docs.cypress.io/faq/questions/using-cypress-faq#Is-there-any-way-to-detect-if-my-app-is-running-under-Cypress
 * @see https://stackoverflow.com/questions/50940640/how-to-determine-if-jest-is-running-the-code-or-not/52231746#52231746
 */
export const isRunningTests = (): boolean =>
  process.env.JEST_WORKER_ID !== undefined || (window && (window as any).Cypress);
